<cpc-language-switch [activeLanguage]="activeLanguage"
    [languages]="languages" (changeLanguage)="changeLanguage($event)">
</cpc-language-switch>